import { useState } from "react";
import { Link } from "react-router-dom";
import { matches } from "@/mocks/matches";
import { getTeam, formatDateCN, uniqueDates } from "@/utils";

const regions = ["全部", "东部", "西部"];

export default function QuickNav() {
  const dates = uniqueDates(matches.map((m) => m.date));
  const [date, setDate] = useState("2026-10-09");
  const [region, setRegion] = useState("全部");

  const filtered = matches
    .filter((m) => m.date === date)
    .filter((m) => region === "全部" || m.region === region)
    .sort((a, b) => a.time.localeCompare(b.time));

  return (
    <div className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-5">
      <div className="flex items-center gap-3 mb-4">
        <span className="w-1.5 h-6 rounded-full bg-primary-500"></span>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950">直播入口快捷导航</h2>
          <p className="text-xs text-foreground-500 mt-0.5">按日期与赛区筛选，快速直达对应比赛直播间</p>
        </div>
      </div>

      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1 mb-3">
        {dates.map((d) => (
          <button
            key={d}
            type="button"
            onClick={() => setDate(d)}
            className={`px-3.5 py-2 rounded-md text-xs font-label whitespace-nowrap transition-colors cursor-pointer ${
              date === d ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            {formatDateCN(d)}
          </button>
        ))}
      </div>

      <div className="inline-flex items-center gap-1 bg-background-100 rounded-full p-1 mb-4">
        {regions.map((r) => (
          <button
            key={r}
            type="button"
            onClick={() => setRegion(r)}
            className={`px-4 py-1.5 rounded-full text-xs font-label transition-colors cursor-pointer ${
              region === r ? "bg-secondary-500 text-background-50" : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            {r}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="py-10 text-center text-foreground-400 flex flex-col items-center gap-2">
          <i className="ri-search-eye-line text-3xl"></i>
          <p className="text-sm">暂无符合条件的直播比赛</p>
        </div>
      ) : (
        <div className="flex flex-col divide-y divide-background-200">
          {filtered.map((m) => (
            <Link
              key={m.id}
              to={`/match/${m.id}`}
              className="group flex items-center justify-between gap-3 py-3 cursor-pointer"
            >
              <div className="flex items-center gap-2 min-w-0">
                <span className="font-label text-xs text-foreground-500 w-10 shrink-0">{m.time}</span>
                <span className="text-sm text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {getTeam(m.home).short} <span className="text-foreground-400 text-xs">vs</span> {getTeam(m.away).short}
                </span>
                {m.status === "live" && (
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-[10px] font-label shrink-0">
                    <span className="w-1 h-1 rounded-full bg-accent-600 animate-pulse-dot"></span> LIVE
                  </span>
                )}
              </div>
              <span className="text-xs text-primary-600 group-hover:text-accent-600 flex items-center gap-1 shrink-0 whitespace-nowrap">
                直播入口 <i className="ri-arrow-right-s-line"></i>
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}